import { cn } from '@/lib/utils'

interface PanelSeparatorProps {
  className?: string
}

export function PanelSeparator({ className }: PanelSeparatorProps) {
  return (
    <div
      className={cn('w-full border-px border-b border-ring/50', className)}
    ></div>
  )
}
